/*import axios from 'axios'
import React, { Component } from 'react'*/
import React, { Component } from 'react'
import $ from 'jquery';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { NavbarLog } from '../../navbar/NavbarLog';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText } from 'reactstrap';
//import "./Carrera.css";
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

//Rutas de ingreso de matriz
const baseUrlPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarBecasEstudsxPeriodo = ApiUrl + "ListarBecasEstudsxPeriodo" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

let listaauxiliar = [];
const itemsPerPage = 3;

export default class EstCarreraCicloBecas extends Component {

    constructor(props) {
        super(props)

        this.state = {
            periodos: [],
            periodosId: [],
            periodoId: '',
            EstudianteBackup: [],
            periodo: '',
            periodoesc: '',
            modalReportIngresarBecas: false,

            //nuevas variables
            periodosId: [],
            listabecas: [],
            periodos: [],
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
    }


    handleChangePeriodo = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        var perio = this.state.idPeriodo;
        this.setState({ periodoesc: perio })
    }

    handleChangeListarEstBecas = async (e) => {

        axios
            .post(urlListarBecasEstudsxPeriodo, {
                idPeriodo: this.state.periodoesc,
            })
            .then(response => {
                const respuesta = response.data.data;
                this.setState({ listabecas: respuesta });
                listaauxiliar = this.state.listabecas;
                var cantidadestud = listaauxiliar.length;
                this.setState({ cantidadestud });
                //BÚSQUEDA
                const EstudianteBackup = this.state.listabecas;

                this.setState((state) => {
                    return { EstudianteBackup: EstudianteBackup }
                });

                //PAGINACION
                this.state.itemOffset = 0;
                const endOffset = this.state.itemOffset + itemsPerPage;
                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });

                this.setState((state) => {
                    return { itemOffset: state.itemOffset + endOffset }
                });

                //FIN DE LA PAGINACION
            })
    }

    componentDidMount = async (e) => {
        //listar todos los periodos
        axios
            .get(baseUrlPeriodos, {})
            .then(response => {
                const listaperiodos = response.data.data;
                const cant = listaperiodos.length;
                if (cant != 0) {
                    this.setState({ periodos: listaperiodos });
                }
            })
    }

    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ EstudianteBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            // Importante: lee state en vez de this.state al actualizar.
            return { itemOffset: newOffset }
        });
    }
    //FIN DE PAGINACION

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas">
                        <i className="fa fa-comment-dollar bounce-custom fs-5"></i>
                        <b className="mb-0 fw-semibold"> Asignar becas a estudiantes</b>
                    </div>

                    <div className="p-3 rounded-3 mt-1">
                        <div className="row g-3 align-items-end">
                            <div className="col-12 col-md-6 col-xl-4">
                                <label className="form-label text-muted small">
                                    <i className="fa fa-calendar me-1"></i> Período:
                                </label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idPeriodo"
                                    value={this.state.value}
                                    onChange={this.handleChangePeriodo}
                                    aria-label="Default select example"
                                >
                                    <option value="undefined" selected disabled>Seleccione el período</option>
                                    {this.state.periodos.map(periodo => (
                                        <option key={periodo.id_periodo_academico} value={periodo.id_periodo_academico}>
                                            {periodo.descripcion_periodo_academico}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-12 col-md-6 col-xl-4 d-flex gap-2">
                                <button
                                    className="btn btn-sm back-istmas"
                                    type="button"
                                    onClick={this.handleChangeListarEstBecas}
                                >
                                    Consultar
                                </button>
                                <ReactHTMLTableToExcel
                                    id="botonExportarExcel"
                                    className="btn btn-sm btn-success"
                                    table="tablaestbecadosexcel"
                                    filename="EstudiantesBecadosExcel"
                                    sheet="pagina 1"
                                    buttonText="Exportar a Excel"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card shadow-sm border-0">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table id="tablaestbecadosexcel" className="table table-sm-custom table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-start text-azul">Estudiante</th>
                                        <th className="text-start text-azul">Monto</th>
                                        <th className="text-start text-azul">% Arancel</th>
                                        <th className="text-start text-azul">% Manutención</th>
                                        <th className="text-start text-azul">Tipo</th>
                                        <th className="text-start text-azul">Financiamiento</th>
                                        <th className="text-start text-azul">Razón 1</th>
                                        <th className="text-start text-azul">Razón 2</th>
                                        <th className="text-start text-azul">Razón 3</th>
                                        <th className="text-start text-azul">Razón 4</th>
                                        <th className="text-start text-azul">Razón 5</th>
                                        <th className="text-start text-azul">Razón 6</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.currentItems && this.state.currentItems.map((consola) => (
                                        <tr key={consola.estudiante_id}>
                                            <td>{`${consola.primer_nombre_estudiante} ${consola.segundo_nombre_estudiante} ${consola.primer_apellido_estudiante} ${consola.segundo_apellido_estudiante}`}</td>
                                            <td>${consola.monto}</td>
                                            <td>{consola.porcentaje_arancel}%</td>
                                            <td>{consola.porcentaje_manuntencion}%</td>
                                            <td>{consola.tipo_beca_id == "1" ? "Total" : consola.tipo_beca_id == "2" ? "Parcial" : "NA"}</td>
                                            <td>{
                                                consola.financiamiento_beca == "1" ? "Fondos Propios" :
                                                consola.financiamiento_beca == "2" ? "Transferencia del estado" :
                                                consola.financiamiento_beca == "3" ? "No Donaciones" : "NA"
                                            }</td>
                                            <td>{consola.primera_razon_beca == "1" ? "Socioeconómica" : "NA"}</td>
                                            <td>{consola.segunda_razon_beca == "1" ? "Excelencia" : "NA"}</td>
                                            <td>{consola.tercera_razon_beca == "1" ? "Deportista" : "NA"}</td>
                                            <td>{consola.cuarta_razon_beca == "1" ? "Pueblos y Nacionalidades" : "NA"}</td>
                                            <td>{consola.quinta_razon_beca == "1" ? "Discapacidad" : "NA"}</td>
                                            <td>{consola.sexta_razon_beca == "1" ? "Otra" : "NA"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="d-flex justify-content-center mt-3">
                            <ReactPaginate
                                nextLabel=">"
                                onPageChange={this.handlePageClick}
                                pageRangeDisplayed={5}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                previousLabel="<"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                containerClassName="pagination pagination-sm-custom"
                                activeClassName="active"
                                renderOnZeroPageCount={null}
                            />
                        </div>
                        <div class="table-responsive" hidden>
                            <table id="tablaestbecadosexcel" className="table text-left table-bordered">
                                <thead >
                                    <tr>
                                        <th scope="col">ESTUDIANTE</th>
                                        <th scope="col">MONTO</th>
                                        <th scope="col">%ARANCEL</th>
                                        <th scope="col">%MANUTENC</th>
                                        <th scope="col">TIPO</th>
                                        <th scope="col">FINANCIAM</th>
                                        <th scope="col">RAZÓN1</th>
                                        <th scope="col">RAZÓN2</th>
                                        <th scope="col">RAZÓN3</th>
                                        <th scope="col">RAZÓN4</th>
                                        <th scope="col">RAZÓN5</th>
                                        <th scope="col">RAZÓN6</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.listabecas.map((consola) => (
                                        <tr key={consola.estudiante_id}>
                                            <td class="estudiante">{consola.primer_nombre_estudiante + " " + consola.segundo_nombre_estudiante + " " + consola.primer_apellido_estudiante + " " + consola.segundo_apellido_estudiante}</td>
                                            <td class="monto">{consola.monto}</td>
                                            <td class="arancel">{consola.porcentaje_arancel}</td>
                                            <td class="manutencion">{consola.porcentaje_manuntencion}</td>
                                            <td scope="tipo">
                                                {(() => {
                                                    if (consola.tipo_beca_id == "1")
                                                        return <span>Total</span>
                                                    if (consola.tipo_beca_id == "2")
                                                        return <span>Parcial</span>
                                                    if (consola.tipo_beca_id == "3")
                                                        return <span>NA</span>
                                                })()}
                                            </td>
                                            <td scope="financiamiento">
                                                {(() => {
                                                    if (consola.financiamiento_beca == "1")
                                                        return <span>Fondos Propios</span>
                                                    if (consola.financiamiento_beca == "2")
                                                        return <span>Transferencia del estado</span>
                                                    if (consola.financiamiento_beca == "3")
                                                        return <span>No Donaciones</span>
                                                    if (consola.financiamiento_beca == "4")
                                                        return <span>NA</span>
                                                })()}
                                            </td>
                                            <td scope="razon1">
                                                {(() => {
                                                    if (consola.primera_razon_beca == "1")
                                                        return <span>Socioeconómica</span>
                                                    if (consola.primera_razon_beca == "2")
                                                        return <span>NA</span>
                                                })()}
                                            </td>
                                            <td scope="razon2">
                                                {(() => {
                                                    if (consola.segunda_razon_beca == "1")
                                                        return <span>Excelencia</span>
                                                    if (consola.segunda_razon_beca == "2")
                                                        return <span>NA</span>
                                                })()}
                                            </td>
                                            <td scope="razon3">
                                                {(() => {
                                                    if (consola.tercera_razon_beca == "1")
                                                        return <span>Deportista</span>
                                                    if (consola.tercera_razon_beca == "2")
                                                        return <span>NA</span>
                                                })()}
                                            </td>
                                            <td scope="razon4">
                                                {(() => {
                                                    if (consola.cuarta_razon_beca == "1")
                                                        return <span>Pueblos y Nacionalidades</span>
                                                    if (consola.cuarta_razon_beca == "2")
                                                        return <span>NA</span>
                                                })()}
                                            </td>
                                            <td scope="razon5">
                                                {(() => {
                                                    if (consola.quinta_razon_beca == "1")
                                                        return <span>Discapacidad</span>
                                                    if (consola.quinta_razon_beca == "2")
                                                        return <span>NA</span>
                                                })()}
                                            </td>
                                            <td scope="razon6">
                                                {(() => {
                                                    if (consola.sexta_razon_beca == "1")
                                                        return <span>Otra</span>
                                                    if (consola.sexta_razon_beca == "2")
                                                        return <span>NA</span>
                                                })()}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

